import { render, staticRenderFns } from "./ranking-detail.vue?vue&type=template&id=3f85971f&scoped=true"
import script from "./ranking-detail.vue?vue&type=script&lang=js"
export * from "./ranking-detail.vue?vue&type=script&lang=js"
import style0 from "./ranking-detail.vue?vue&type=style&index=0&id=3f85971f&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f85971f",
  null
  
)

export default component.exports